module.exports = __webpack_public_path__ + "static/media/pla_acc_poi_ste.13da21f9.png";